import { DashboardTileTone } from './DashboardBirdview.constants'

import EmailIcon from '../../icons/email.svg'
import ServiceRequestIcon from '../../icons/service-request.svg'

export const BIRDVIEW_PERSONAL_KPIS_MOCK = {
  myAvgResolution: {
    delta: -0.2,
    spark: [2.4, 2.3, 2.2, 2.1, 2, 2, 1.9, 1.9],
    tone: DashboardTileTone.Success,
    value: 1.9,
  },
  resolvedThisWeek: {
    delta: 6,
    spark: [38, 40, 39, 42, 44, 45, 47, 48],
    tone: DashboardTileTone.Success,
    value: 48,
  },
  onTime: {
    delta: -3,
    spark: [93, 92, 92, 90, 89, 88, 87, 88],
    tone: DashboardTileTone.Error,
    value: 88,
  },
}

export const BIRDVIEW_GRETA_SECTION_MOCK = {
  items: [
    {
      Icon: ServiceRequestIcon,
      id: 'greta-1',
      title: 'Assign Elektro Schmidt → “Heating broken — Bergstraße 16”',
      why: 'why: nearest free provider',
    },
    {
      Icon: EmailIcon,
      id: 'greta-2',
      title: 'Draft reply to Ms Müller — “technician booked Thu 9:00”',
      why: 'why: slot confirmed',
    },
    {
      Icon: ServiceRequestIcon,
      id: 'greta-3',
      title: 'Escalate “Water-damage estimate” — stalled',
      why: 'why: no update 48h',
    },
    {
      Icon: ServiceRequestIcon,
      id: 'greta-4',
      title: 'Tag “Lift defect — Rosenweg 8” as urgent',
      why: 'why: safety category',
    },
  ],
  total: 4,
}
